import { Head, usePage } from "@inertiajs/react"

import { BroadcastShow } from "@/components/broadcast-show"
import { NOISE_PNG } from "@/lib/noise-texture"
import type { SharedProps } from "@/types"

import { BroadcastOpenSection } from "./broadcast-open-section"
import { HeroSection } from "./hero-section"
import { RaceRosterSection } from "./race-roster-section"
import { SeasonArcSection } from "./season-arc-section"
import { SignoffSection } from "./signoff-section"

interface HomePageProps extends SharedProps {
  hero_image_url?: string | null
  action_image_url?: string | null
  commentator_portrait_urls?: Record<string, string>
}

export default function HomePage() {
  const { hero_image_url, action_image_url, commentator_portrait_urls } =
    usePage<HomePageProps>().props

  const portraitUrls = commentator_portrait_urls ?? {}

  return (
    <>
      <Head title="Blood Bowl League Manager" />
      <div
        className="relative min-h-screen"
        style={{
          overflowX: "clip",
          background:
            "repeating-linear-gradient(0deg, oklch(1 0 0 / 0.04) 0px, oklch(1 0 0 / 0.04) 1px, transparent 1px, transparent 4px), linear-gradient(180deg, oklch(0.06 0.01 55) 0%, oklch(0.10 0.015 55) 30%, oklch(0.08 0.01 55) 60%, oklch(0.06 0.01 55) 100%)",
          color: "oklch(0.88 0.01 80)",
        }}
      >
        {/* Global noise texture — no blend mode to avoid per-frame repaint */}
        <div
          className="pointer-events-none fixed inset-0"
          style={{
            backgroundImage: `url('${NOISE_PNG}')`,
            backgroundRepeat: "repeat",
            opacity: 0.07,
            zIndex: 0,
          }}
        />

        <HeroSection heroImageUrl={hero_image_url} />

        {/* Neon divider — threshold between hero and broadcast */}
        <div
          className="relative z-10 h-px"
          style={{
            background:
              "linear-gradient(90deg, transparent 5%, oklch(0.8 0.3 145 / 0.4) 25%, oklch(0.85 0.28 85 / 0.6) 50%, oklch(0.8 0.3 145 / 0.4) 75%, transparent 95%)",
            boxShadow:
              "0 0 8px oklch(0.85 0.28 85 / 0.3), 0 0 20px oklch(0.8 0.3 145 / 0.15)",
          }}
        />

        <BroadcastShow>
          <BroadcastOpenSection
            portraitUrls={portraitUrls}
            keyPlayImageUrl={action_image_url}
          />
          <RaceRosterSection portraitUrls={portraitUrls} />
          <SeasonArcSection portraitUrls={portraitUrls} />
          <SignoffSection portraitUrls={portraitUrls} />
        </BroadcastShow>
      </div>
    </>
  )
}
